import React from "react";
import { useFormat } from "../../i18n/format";

const DateBadge = () => {
  const { locale } = useFormat();
  const currentDate = new Date();

  const month = currentDate
    .toLocaleString(locale, { month: "short" })
    .replace(".", "");
  const day = currentDate.getDate();

  return (
    <div
      className="
        w-9 h-9
        rounded-lg
        overflow-hidden
        shadow-sm
        bg-ui-surface
        border border-ui-border
        flex flex-col
        hover:shadow-md
        transition-shadow duration-200
      "
    >
      {/* Header */}
      <div className="h-[40%] bg-gradient-to-r from-brand to-brand flex items-center justify-center">
        <span className="text-[7px] font-semibold text-white uppercase tracking-wider">
          {month}
        </span>
      </div>

      {/* Body */}
      <div className="flex-1 flex items-center justify-center">
        <span className="text-[11px] font-bold text-brand leading-none">
          {day}
        </span>
      </div>
    </div>
  );
};

export default DateBadge;
